import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
} from "reactstrap";
import * as Yup from "yup";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useFormik } from "formik";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Avatar, Spin } from "antd";
import { deleteMedia, uploadImage } from "../../Media/services/mediaApi";
import { createUser, updateUser } from "../../Users/services/userApi";
import { useTranslation } from "react-i18next";
import { UserAddOutlined } from "@ant-design/icons";
import FileField from "../../../Components/Common/Form/FileField";
import FormField from "../../../Components/Common/Form/FormField";

const AddEditDriverForm = ({ modal, setModal, toggle, selectedUser }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);

  const category = "user";

  const handlePhotoFileUpdate = (fileItems) => {
    setImage(fileItems.length > 0 ? fileItems[0].file : null);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Oups!!! Veuillez renseigner le nom complet"),
    email: Yup.string().email("Veuillez renseigner une adresse email valide").required("Veuillez renseigner l'adresse email"),
    phone: Yup.number().required("Son numéro de téléphone svp"),
    address: Yup.string().required("Veuillez renseigner l'adresse"),
    licenseNumber: Yup.number().required("Le permis est obligatoire pour les chauffeurs"),
  });

  const initialValues = selectedUser ? {
    name: selectedUser.name,
    email: selectedUser.email,
    phone: selectedUser.phone,
    address: selectedUser.address || "",
    licenseNumber: selectedUser.licenseNumber || "",
    fileName: selectedUser.fileName || "",
  } : {
    name: "",
    email: "",
    phone: "",
    address: "",
    status:"Actif",
    licenseNumber: "",
    role: "DRIVER",
    fileName: "",
    password: "Syst@link123",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      let fileName = values.fileName;
      try {
        if (image) {
          const response = await uploadImage(category, image);
          fileName = response?.name;
        }
        const username = values?.email;
        const userData = {
          ...values,
          username,
          fileName,
          role: { name: values.role},
        };
        if (selectedUser) {
          await updateUser(selectedUser?.id, userData);
          toast.success("Le chauffeur a été modifié avec succès",
            {
              duration: 10000,
            }
          );
        } else {
          await createUser(userData);
          toast.success("L'utilisateur a été créé avec succès avec un mot de passe par défaut : Syst@link123  🎉");
        }
        await queryClient.invalidateQueries("users");
        toggle();
        formik.resetForm();
      } catch (error) {
        toast.error(`😌 Erreur: ${error?.message || error}`);
        if (image && fileName) {
          try {
            await deleteMedia(fileName);
          } catch (deleteError) {
            console.error("Erreur lors de la suppression de l'image :", deleteError);
          }
        }
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedUser]);

  const modalTitle = selectedUser ? t("driverForm.edit_c") : t("driverForm.add_c");

  return (
      <Modal
        id="showModalClient"
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop={"static"}
        style={{ maxWidth: "700px"}}
      >
        <ModalHeader className="d-flex justify-content-center align-items-center p-3">
          <div style={{ color: "#252525", fontSize: "24px", fontWeight: "bold", fontFamily: "Raleway"}}>
            {modalTitle} <UserAddOutlined />
          </div>
        </ModalHeader>

          <Form onSubmit={formik.handleSubmit}>
            <ModalBody>
              <Row className="justify-content-center">
                <Col lg={12} className="text-center mb-4">
                  <Avatar size={{ xs: 24, sm: 32, md: 40, lg: 10, xl: 130, xxl: 100 }}>
                    <FileField name="fileName" formik={formik} file={image} onUpdateFiles={handlePhotoFileUpdate} colSize={12}/>
                  </Avatar>
                </Col>
                <FormField label="Prénom et Nom" name="name" formik={formik} colSize={6} placeholder="Entrez le nom complet"/>
                <FormField label="Email" name="email" formik={formik} type="email" colSize={6} placeholder="L'email est unique à un chauffeur"/>
                <FormField label="Numéro de Permis" name="licenseNumber" formik={formik} placeholder="Renseigner le permis pour les chauffeurs" colSize={6}/>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label labelInput">{t("driverForm.phone")}</label>
                    <PhoneInput
                        international
                        defaultCountry="FR"
                        value={formik.values.phone || ''}
                        onChange={value => formik.setFieldValue('phone', value)} 
                        onBlur={formik.handleBlur}
                        id="phone"
                        name="phone"
                        className="small-phone-input"
                        />
                          {formik.touched.phone && formik.errors.phone && (
                            <div className="text-danger">{formik.errors.phone}</div>
                          )}
                  </div>
                </Col>
                <FormField label="Adresse" name="address" formik={formik} colSize={12} placeholder="Entrez l'adresse du chauffeur"/>
              </Row>
            </ModalBody>
            
            <ModalFooter>
              <div className="d-flex center justify-content-left gap-2 mt-3">
                <Button
                  color="light"
                  className="bordered-btn-lightR btn-spacing justify-content-left gap-2 mt-3"
                  onClick={() => setModal(false)}
                >
                  {t("vehicleForm.cancel")}
                </Button>
                <Button type="submit" className="bordered-btn" disabled={isLoading} style={{   width: "100%", }}>
                  {isLoading ? (
                    <Spin size="small" />
                        ) : selectedUser ? (
                          t("driverForm.edit")
                        ) : (
                          t("driverForm.submit")
                        )}
                </Button>
              </div>
            </ModalFooter>
          </Form>
      </Modal>
  );
};
export default AddEditDriverForm;
